import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=874ad1a4&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./Style/data-table.scss?vue&type=style&index=0&id=874ad1a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874ad1a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('874ad1a4')) {
      api.createRecord('874ad1a4', component.options)
    } else {
      api.reload('874ad1a4', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=874ad1a4&scoped=true&", function () {
      api.rerender('874ad1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/DataTable/DataTable.vue"
export default component.exports